import { request } from '../request'

// 获取用例列表
interface GetUseCaseListParams {
  page?: number
  pageSize?: number
  filterParams?: {
    name?: string
    originType?: string[]
    verificationModeId?: string[]
    attackTypeId?: string[]
    riskLevel?: string[]
    resourceLevel?: string[]
    tagId?: string[]
    method?: string[]
    componentId?: string[]
    attckId?: string[]
    attackOrganizationId?: string[]
    sceneId?: number[]
    sortOrder?: 'SortOrderUnspecified' | 'SortOrderAscending' | 'SortOrderDescending'
    sortField?: 'ResourceSortFieldUpdateTime'
    protocol?: string[]
    attachmentType?: string[]
    resourceIds?: string[]
    resourceBindType?: string
  }
}
const getUseCaseList = (params: GetUseCaseListParams) =>
  request('/portal/common/resources', { method: 'POST', data: params, timeout: 10000 })

// 获取用例列表筛选的全量用例ids
const getUseCaseIds = (params: GetUseCaseListParams) =>
  request('/portal/common/resources/ids', { method: 'POST', data: params })

// 添加用例
interface AddUseCaseParams {
  name: string
  originType: 'OriginTypeSystem' | 'OriginTypeCustom'
  verificationModeId: string
  attackTypeId: string
  riskLevel: 'RiskLevelLow' | 'RiskLevelMiddle' | 'RiskLevelHigh' | 'RiskLevelGross'
  resourceType: string
  resourceLevel: 'ResourceLevelJunior' | 'ResourceLevelMiddle' | 'ResourceLevelSenior'
  deviceType: string[]
  usageSceneIds: number[]
  isEnable: boolean
  payloadParams: {
    body?: string
    cnnvdId?: string[]
    cnvdId?: string[]
    //  影响组件id
    componentId?: string
    cveId?: string[]
    database?: number
    describe?: string
    headers?: { [key: string]: string }
    //  是否启动动态编码
    isDynamicEncoding?: boolean
    language?: number
    method?: 'MethodGet' | 'MethodPost'
    os?: number
    path?: string
    payload?: string
    solution?: string
    //  WAF厂商
    wafFirm: string
  }
  pcapParams?: {}
}
const addUseCase = (params: AddUseCaseParams) =>
  request('/portal/common/resource', { method: 'POST', data: params })

// 编辑用例
interface EditUseCaseParams extends AddUseCaseParams {
  resourceId: string
}
const editUseCase = (params: EditUseCaseParams) =>
  request(`/portal/common/resource/${params.resourceId}`, { method: 'PUT', data: params })

// 删除用例
const deleteUseCase = (ids: string[]) =>
  request(`/portal/common/resource/delete`, { method: 'POST', data: { resourceIds: ids } })

// 获取用例详情（仅公共属性）
const getUseCaseDetail = (resourceId: string) =>
  request(`/portal/common/resource/${resourceId}`, { method: 'GET' })

// 获取用例详情（web安全）
const getUseCaseDetailWebSecurity = (resourceId: string) =>
  request(`/portal/common/resource/waf/${resourceId}`, { method: 'GET' })

// 获取用例标签列表（筛选）
const getUseCaseTagList = (params: any) =>
  request('/portal/common/resources/tag/list', { method: 'POST', data: params })

// 批量导入用例
interface BatchImportUseCaseParams {
  fileId: string
  verificationModeId: number
  usageSceneId: number[]
  resourceType: string | number
}
const batchImportUseCase = (params: BatchImportUseCaseParams) =>
  request('/portal/common/resource/batch_import', {
    method: 'POST',
    data: params,
    timeout: 300000,
  })

const batchImportWgUseCase = (params: BatchImportUseCaseParams) =>
  request('/portal/verify/webGateway/importResource', {
    method: 'GET',
    params,
    timeout: 300000,
  })

// 攻击组织（筛选）
const getAttackOrganizationList = () =>
  request('/portal/common/resources/apt_list', { method: 'POST', data: {} })

// 影响组件（筛选）
const getComponentList = (params: any) =>
  request('/portal/common/resources/component/list', {
    method: 'POST',
    data: params,
  })

// 战术列表（筛选）
const getTacticsList = (params: any) =>
  request('/portal/basic/tactics/list', { method: 'POST', data: params })

// 添加用例（终端安全）
const addESUseCase = params =>
  request('/portal/v1/endpoint_security/custom_plugin', { method: 'POST', data: params })

// 编辑用例（终端安全）
const editESUseCase = (params: any) =>
  request(`/portal/v1/endpoint_security/custom_plugin/${params.resourceId}`, {
    method: 'PUT',
    data: params,
  })

// 获取用例详情（终端安全）
const getESUseCaseDetail = (resourceId: string) =>
  request(`/portal/v1/endpoint_security/custom_plugin/${resourceId}`, { method: 'GET' })

// 添加邮件安全附件
const addMailAttachment = (params: any) =>
  request('/portal/common/attachment', { method: 'POST', data: params, timeout: 300000 })

// 创建邮件安全附件用例
const createMailAttachmentUseCase = (params: any) =>
  request('/portal/common/resource/email/attachment', { method: 'POST', data: params })

// 编辑邮件安全附件用例
const editMailAttachmentUseCase = (params: any) =>
  request(`/portal/common/resource/email/attachment/${params.resourceId}`, {
    method: 'PUT',
    data: params,
  })

// 获取邮件安全附件用例详情
const getMailAttachmentUseCaseDetail = (resourceId: string) =>
  request(`/portal/common/resource/email/attachment/${resourceId}`, { method: 'GET' })

// 添加邮件安全URL用例
const addMailUrlUseCase = (params: any) =>
  request('/portal/common/resource/email/url', { method: 'POST', data: params })

// 编辑邮件安全URL用例
const editMailUrlUseCase = (params: any) =>
  request(`/portal/common/resource/email/url/${params.resourceId}`, {
    method: 'PUT',
    data: params,
  })

// 获取邮件安全URL用例详情
const getMailUrlUseCaseDetail = (resourceId: string) =>
  request(`/portal/common/resource/email/url/${resourceId}`, { method: 'GET' })

// 添加流量安全用例
const addTpUseCase = (params: any) =>
  request('/portal/verify/tp/plugins', { method: 'POST', data: params })

// 编辑流量安全用例
const editTpUseCase = (params: any) =>
  request(`/portal/verify/tp/plugins/${params.resourceId}`, {
    method: 'PUT',
    data: params,
  })

// 获取流量安全用例详情
const getTpUseCaseDetail = (id: string) =>
  request(`/portal/verify/tp/plugins/${id}`, { method: 'GET' })

// 恶意文件上传文件
const uploadMaliciousFile = (params: any) =>
  request('/portal/v1/endpoint_security/custom_plugin/generic_file_drop/file', {
    method: 'POST',
    data: params,
  })

// 添加威胁情报用例
const addWgUseCase = (params: any) =>
  request('/portal/verify/web_gateway/resource', { method: 'POST', data: params, timeout: 100000 })

// 编辑威胁情报用例
const editWgUseCase = (params: any) =>
  request(`/portal/verify/web_gateway/resource/${params.resourceId}`, {
    method: 'PUT',
    data: { ...params, resourceId: undefined },
    timeout: 100000,
  })

// 获取威胁情报用例详情
const getWgUseCaseDetail = (id: string) =>
  request(`/portal/verify/web_gateway/resource_detail/${id}`, { method: 'GET' })

// 获取全场景攻击类型
const getAllAttackType = () =>
  request('/portal/common/attack_types', {
    method: 'GET',
    params: {
      page: 1,
      pageSize: 0,
    },
  })

// 获取全部攻击类型
const getAttackTypes = () =>
  request('/portal/common/attack/attack_type_filter_list', {
    method: 'GET',
    params: {
      queryType: 'query_type_resource_list',
      'resourceListQuery.originType': 1,
    },
  })

export {
  getUseCaseList,
  getUseCaseIds,
  addUseCase,
  editUseCase,
  deleteUseCase,
  getUseCaseDetail,
  getUseCaseDetailWebSecurity,
  getUseCaseTagList,
  batchImportUseCase,
  batchImportWgUseCase,
  getAttackOrganizationList,
  getComponentList,
  GetUseCaseListParams,
  AddUseCaseParams,
  BatchImportUseCaseParams,
  EditUseCaseParams,
  getTacticsList,
  addESUseCase,
  editESUseCase,
  getESUseCaseDetail,
  addMailAttachment,
  createMailAttachmentUseCase,
  editMailAttachmentUseCase,
  getMailAttachmentUseCaseDetail,
  addMailUrlUseCase,
  editMailUrlUseCase,
  getMailUrlUseCaseDetail,
  addTpUseCase,
  editTpUseCase,
  getTpUseCaseDetail,
  uploadMaliciousFile,
  addWgUseCase,
  editWgUseCase,
  getWgUseCaseDetail,
  getAllAttackType,
  getAttackTypes,
}
